// export const baseUrl = "https://hwaidakhotelsapi.titegypt.org";
export const baseUrl = "https://api.hwaidakhotels.com";
